<template>
  <div class="themeItem_cardList_container" v-if="themeItem">
    <span class="cardItem_topBg"></span>
    <span class="cardItem_main">
      <span
        v-for="(cell, cellIndex) in themeItem.list"
        :key="cellIndex"
        class="cardItem_row"
        :class="themeItem.mode"
      >
        <span class="rankNo" v-text="cell.rank"></span>
        <span class="cardItem_row_image" v-if="cell.imageUrl">
          <img :src="cell.imageUrl" />
        </span>
        <span v-else class="cardItem_row_image defautlPlayerLogo"></span>
        <span
          class="cardItem_row_center"
          v-if="themeItem.mode === 'overviewPlayerData'"
        >
          <span class="cardItem_row_name" v-text="cell.shortName"></span>
          <span class="cardItem_row_teamName" v-text="cell.teamName"></span>
        </span>
        <span v-else class="cardItem_row_name" v-text="cell.shortName"></span>
        <span class="cardItem_row_val" v-text="cell.val"></span>
      </span>
    </span>
  </div>
</template>

<script>
// 足球 球队 || 球员 =>  球队进球榜 | 射手榜 等等  主题  【支持竖向滚动】
export default {
  name: 'themeItem_cardList_container',
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    cType: {
      type: String,
      default: '',
    },
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug(
          'themeItem_cardList_container 重新刷新数据:',
          newVal,
          oldVal
        )
        if (newVal && newVal.data) {
          this.themeItem = this.computedTableData(newVal)
        }
      },
      immediate: false,
      deep: true,
    },
  },
  data() {
    return {
      themeItem: null,
    }
  },
  //   watch: {
  //     datas(newVal, oldVal) {
  //       if (
  //         newVal &&
  //         JSON.stringify(newVal.data.dataList) !==
  //           JSON.stringify(oldVal.data.dataList)
  //       ) {
  //         this.list = this.computedMedalList(newVal.data.dataList)
  //       }
  //     },
  //     immediate: false,
  //     deep: true,
  //   },
  created() {
    this.themeItem = this.computedTableData(this.datas)
  },
  mounted() {},
  methods: {
    computedTableData(datas) {
      let themeItem = {}
      let mode = null
      let list = datas.data.dataList.map((item) => {
        if (!mode) {
          mode = item.playerId ? 'overviewPlayerData' : 'overviewTeamData'
        }
        if (this.cType && this.cType === 'marathon') {
          // 马拉松
          return {
            imageUrl: item.athleteNum ? item.profilePicture : '',
            id: item.athleteNum,
            shortName: item.athleteNum ? item.athleteName : '',
            val: item.num,
            rank: item.rank,
          }
        } else {
          // 世界杯
          return {
            imageUrl: item.playerId ? item.playerLogo : item.teamLogo,
            id: item.playerId ? item.playerId : item.teamId,
            shortName: item.playerId ? item.playerName : item.teamName,
            val: item.num,
            rank: item.rank,
            teamName: item.teamName ? item.teamName : '',
          }
        }
      })
      themeItem.list = list
      themeItem.mode = mode
      return themeItem
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.themeItem_cardList_container {
  position: relative;
  width: 90%;
  padding: 0.694vw 0;
  .cardItem_topBg {
    position: absolute;
    top: 0.254vw;
    left: 0;
    z-index: 2;
    display: block;
    width: 100%;
    height: 0.42vw;
    border-radius: 0.21vw;
    background-color: var(--mixtmt_mainColor8);
  }
  .cardItem_main {
    display: block;
    width: 100%;
    max-height: calc(21.54vw - 1.388vw);
    height: auto;
    /* border: 1px solid var(--mixtmt_mainColor8);
    border-top: none; */
    color: var(--mixtmt_greyColor3);
    overflow-y: auto;
    .cardItem_main_title {
      display: block;
      width: 100%;
      height: 4.166vw;
      line-height: 4.166vw;
      font-size: 1.25vw;
      text-align: center;
    }
    .cardItem_row {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 2.083vw;
      width: 100%;
      height: calc(3.6vw + 1px);
      border-top: 1px solid var(--mixtmt_greyColor7);
      &:first-child {
        border-top: 0;
      }
      .cardItem_row_image {
        position: relative;
        width: 2.776vw;
        height: 2.776vw;
        border-radius: 50%;
        overflow: hidden;
        &.defautlPlayerLogo {
          background-size: 100% auto;
          background-repeat: no-repeat;
          background-position: center bottom;
          background-image: var(--mixtmt_default_playerLogo);
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        &::before {
          content: '\20';
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
      }
      &.overviewTeamData,
      &.overviewPlayerData {
        padding: 0 0.694vw;
        .rankNo {
          padding-right: 0.694vw;
          width: 2.083vw;
          font-size: 0.972vw;
          font-weight: bold;
          text-align: center;
        }
        .cardItem_row_center {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          width: calc(100% - 2.083vw - 2.776vw - 3.472vw);
          .cardItem_row_name {
            width: 100%;
            padding-left: 0.833vw;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 0.972vw;
            font-weight: bold;
          }
          .cardItem_row_teamName {
            width: 100%;
            padding-left: 0.833vw;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 0.833vw;
            color: var(--mixtmt_greyColor4);
          }
        }
        .cardItem_row_name {
          width: calc(100% - 2.083vw - 2.776vw - 3.472vw);
          padding-left: 0.833vw;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 0.972vw;
        }
        .cardItem_row_val {
          width: 3.472vw;
          text-align: right;
          padding-left: 0.833vw;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 0.972vw;
        }
      }
      &.overviewTeamData {
        .cardItem_row_name {
          width: calc(100% - 1.388vw - 2.083vw - 6.94vw);
        }
        .cardItem_row_val {
          width: 6.94vw;
        }
      }
    }
  }
}
</style>
